<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1">
<i>For all women, perhaps especially the younger ones—</i><br/>
<i>Jan, Noelle, Kali, Rachel, Luna, Josie, Ariel, Sujata, Hannah, Jessa,</i><br/>
<i>Meralyn, Gemma, Jane, Magdalena, Chloe, Ella, Olivia, Janiya,</i><br/>
<i>Mirabai,Vernit, and Ava.</i>
</div>
<div>
     <br/>
</div>
<div>
     <br/>
</div>
<div class="ctag1 sgc-1">
    May your lives be fulfilling, balanced, and joyful.
  </div>
<div>
     <br/>
</div>
<div>
     <br/>
</div>
<div class="ctag1">
<i>And for dear Lucy and Lillian. May</i><br/>
<i>they each rest in profound peace.</i>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// clau_9780738214993_oeb_ded_r1.vue?2b9833bd